<!--裁判文书-->
<template>
  <div class="adjudicative-container">
    <header-index/>
    <div class="adjudicative-content">
      <div class="adjudicative-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/ServiceCentre/serviceCloud?pName='+cityList.abridge+'企服务云' }">
            {{ cityList.abridge }}企服务云
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/enterpriseSearch/index' }">企业查询</el-breadcrumb-item>
          <el-breadcrumb-item>裁判文书</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="adjudicative-top">
        <p class="adjudicative-title">查询裁判文书</p>
        <el-input placeholder="请输入案号、当事人、案由等关键词" v-model="keyword" class="input-with-select" style="width: 45%;"
                  @keyup.enter.native="getAdjudicativeInfo">
          <el-button type="danger" slot="append" @click="getAdjudicativeInfo">查一下</el-button>
        </el-input>
      </div>
      <div class="adjudicative-info">
        <div class="adjudicative-search-menu">
          <span>最新裁判文书</span>
          <div>
            <el-select v-model="cause" placeholder="案由" style="width: 170px;margin-right: 20px" clearable>
              <el-option v-for="item in causeType" :label="item.name" :value="item.name"/>
            </el-select>
            <el-date-picker v-model="year" value-format="yyyy" type="year" placeholder="年份" style="width: 170px"/>
          </div>
        </div>
        <div class="adjudicative-list" v-if="adjudicativeInfo.length>0">
          <div v-for="info of adjudicativeInfo" class="adjudicative-list-item" @click="getAdjudicativeDetails(info)">
            <p class="adjudicative-small-title">{{ info.title }}</p>
            <p>
              <span class="adjudicative-gray">案号：</span>
              <span class="adjudicative-black">{{ info.caseNumber }}</span>
            </p>
            <p>
              <span class="adjudicative-gray">案由：</span>
              <span class="adjudicative-black">{{ info.summaryName }}</span>
            </p>
            <p>
              <span class="adjudicative-gray">裁判日期：</span>
              <span class="adjudicative-black">{{ info.courtName }}</span>
            </p>
            <p>
              <span class="adjudicative-gray">发布日期：</span>
              <span class="adjudicative-black">{{ info.dateIssue }}</span>
            </p>
          </div>
        </div>
        <div v-else>
          <el-empty description="暂无内容"/>
        </div>
        <page :total="tablePage.total" class="pagination" @currentPage="currentPage" :page="tablePage.currentPage"
              :limit="tablePage.pageSize" style="padding: 0px 25px 15px 10px;"/>
      </div>
    </div>
    <home_footer/>
    <Hang/>

  </div>
</template>

<script>
import HeaderIndex from "@/components/header/headerIndex";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
import page from "@/components/page/pages";
import cityJson from "@/static/cityJson.json";
import {LegalProceedingsclassification,getLegalProceedingsBySummary} from '@/api/enterprise_searchApi'
import {getLegalProceedingsDetailsByid} from '@/api/enterpriseDetailsApi'
export default {
  name: "adjudicativeDocument",
  components: {Hang, Home_footer, HeaderIndex,page},
  data() {
    return {
      keyword: '',
      cid: 0,
      cityList: {},
      year: '',
      cause: '',
      causeType: [],
      adjudicativeInfo:[],
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },
  watch: {
    year(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getAdjudicativeInfo();
      }
    },
    cause(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getAdjudicativeInfo();
      }
    },
  },
  methods:{
    /*获取裁判文书*/
    getAdjudicativeInfo(){
      getLegalProceedingsBySummary({
        caseType: '',
        date: this.year,
        documentType: '',
        keyword: this.keyword,
        page: this.tablePage.currentPage,
        summer: this.cause,
        trialProcess: ''
      }).then(res=>{
        if (res.code==200){
          this.tablePage.total=parseInt(res.content.total);
          this.adjudicativeInfo=res.content.rows;
          console.log(res.content.rows);
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getAdjudicativeInfo();
    },
    /*获取案由分类*/
    getCauseType(){
      LegalProceedingsclassification().then(res=>{
        if (res.code==200){
          this.causeType=res.content;
        }
      })
    },
    /*裁判文书详情*/
    getAdjudicativeDetails(info){
      this.$router.push({path: '/enterpriseDetails/legalProceedingsDetail?id=' + info.id});
    }
  },
  mounted() {
    this.getCauseType();
    this.getAdjudicativeInfo();
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    if (sessionStorage.getItem('setPositioning')){
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name){
          this.cityList = li;
        }
      }
    }
  }
}
</script>
<style scoped>
.adjudicative-container >>> .adjudicative-content .adjudicative-top .el-input__inner {
  background-color: #ffffff;
  border-radius: 6px 0px 0px 6px;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 16px;
  height: 55px;
  line-height: 55px;
  padding: 0 20px;
  border-right: none;
}

.adjudicative-container >>> .adjudicative-content .adjudicative-top input::-webkit-input-placeholder {
  color: #333333;
}

.adjudicative-container >>> .adjudicative-content .adjudicative-top .el-input__suffix {
  display: flex;
  align-items: center;
  right: 10px;
}

.adjudicative-container >>> .adjudicative-content .adjudicative-top .el-icon-search {
  font-size: 19px;
}

.adjudicative-container >>> .adjudicative-content .adjudicative-top .el-input-group__append, .el-input-group__prepend {
  background-color: #FE273B;
  color: #fff;
  border: 1px solid #FE273B;
  border-radius: 0px 6px 6px 0px;
  padding: 0 20px;
}

.adjudicative-container >>> .adjudicative-content .adjudicative-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #666666;
}

.adjudicative-container >>> .adjudicative-content .adjudicative-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.adjudicative-container >>> .adjudicative-content .adjudicative-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.adjudicative-container >>> .adjudicative-content .adjudicative-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.adjudicative-container >>> .adjudicative-content .adjudicative-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}

.adjudicative-container >>> .adjudicative-content .adjudicative-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}

.adjudicative-container >>> .adjudicative-content .adjudicative-breadcrumb .el-breadcrumb__inner a,
.adjudicative-container >>> .adjudicative-content .adjudicative-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}

.adjudicative-container >>> .adjudicative-content .adjudicative-info .adjudicative-search-menu input::-webkit-input-placeholder {
  color: #333333;
}
</style>
<style scoped lang="scss">
.adjudicative-container {
  background: #E7E9F5;
  .adjudicative-content {
    .adjudicative-breadcrumb {
      padding: 10px 18%;
      min-width: 76rem;
      background: #E7E9F5;
    }

    .adjudicative-top {
      background: url("~@/assets/img/enterprise/enterprise_search.png") no-repeat;
      height: 300px;
      min-width: 76rem;
      background-size: 100% 100%;
      text-align: center;
      padding: 0px 18%;
      .adjudicative-title {
        color: #ffffff;
        font-size: 48px;
        font-family: 'SourceHanSansCN';
        cursor: pointer;
        margin-block-start: 0px;
        margin-block-end: 0px;
        padding: 70px 0px 50px;
        font-weight: bold;
      }
    }

    .adjudicative-info {
      margin: 20px 18%;
      background: #FFFFFF;
      padding: 15px 0px;
      min-width: 76rem;
      .adjudicative-search-menu {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #E7E9F5;
        align-items: center;
        padding-bottom: 15px;
        padding-left: 20px;
        padding-right: 20px;

        span {
          font-size: 14px;
          font-family: 'SourceHanSansCN';
          color: #333333;
        }
      }

      .adjudicative-list {
        .adjudicative-list-item {
          border-bottom: 1px solid #E7E9F5;
          padding: 20px;

          .adjudicative-small-title {
            font-size: 18px;
            font-family: 'SourceHanSansCN';
            color: #333333;
            padding-bottom: 15px;
          }

          .adjudicative-gray {
            color: #666666;
            font-size: 14px;
            font-family: 'SourceHanSansCN';
          }

          .adjudicative-black {
            color: #333333;
            font-size: 14px;
            font-family: 'SourceHanSansCN';
          }
          .adjudicative-120{
            min-width: 120px;
            display: inline-block;
          }
          .adjudicative-200{
            min-width: 200px;
            display: inline-block;
          }
          p {
            margin-block-end: 0px;
            margin-block-start: 0px;
            padding-bottom: 5px;
          }
        }
      }
    }
  }
}
</style>